module.exports = __webpack_public_path__ + "img/logo.5b3291e4.png";